<template>
  <div class="wg-card wg-danger" id="wg-danger">
    <div class="wg-sec-title">Danger Zone</div>
    <div class="wg-sec-sub">Irreversible actions for this project.</div>

    <div class="wg-danger-acts">
      <button class="wg-pill solid-red" @click="showDeleteModal = true">Delete project</button>
    </div>

    <wg-modal
      :open="showDeleteModal"
      title="Delete this project?"
      :body="`This permanently deletes &quot;${site.name}&quot;, its content plans, audits and history. This cannot be undone. Type the project name to confirm.`"
      icon="delete"
      tone="danger"
      confirm-label="Delete project"
      confirm-tone="danger"
      :require-text="site.name || ''"
      :busy="deleting"
      busy-label="Deleting…"
      @confirm="deleteProject"
      @close="showDeleteModal = false"
    />
  </div>
</template>

<script>
import WgModal from '@/components/SitesSingleView/WhiteGlove/Settings/WgModal.vue'

export default {
  name: 'DangerZoneCard',
  components: { WgModal },
  inject: ['wgToast'],
  props: {
    site: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      showDeleteModal: false,
      deleting: false,
    }
  },
  methods: {
    deleteProject () {
      if (this.deleting) return
      this.deleting = true
      this.$store.dispatch('removeSite', { siteId: this.site.id })
        .then(() => {
          this.showDeleteModal = false
          this.$emit('deleted')
          // keep the sites list in sync for when the user goes back to All Sites
          return this.$store.dispatch('loadSites').then((response) => {
            if (response.data && response.data.status === 'SUCCESS') {
              this.$store.commit('setSites', response.data.sites)
            }
          })
        })
        .catch((error) => {
          // a 400 carries the reason (a live POP Authority package blocks the delete)
          const msg = error?.response?.data?.msg || 'Could not delete the project'
          this.wgToast(msg, null, 'error')
        })
        .finally(() => {
          this.deleting = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './settings-card.scss';

.wg-danger-acts {
  display: flex;
  gap: 14px;
}
</style>
